module.exports = __webpack_public_path__ + "assets/img/product_empty.9338fcbe.svg";